import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SideCardType } from "../util/QuestionStatus";

export interface UiState {
  statusClicked: SideCardType;
}

const initialState: UiState = {
  statusClicked: SideCardType.NeedApproval,
};

export const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setStatusClicked(state, action: PayloadAction<SideCardType>) {
      state.statusClicked = action.payload;
    },
  },
});

export const { setStatusClicked } = uiSlice.actions;
export default uiSlice.reducer;
